/**
 * @generated SignedSource<<dfa4628cd15f0809f9742d74dfa51756>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueKeyCell59BadPattern$data = {
  readonly fieldsById?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly fieldId?: string;
        readonly status?: {
          readonly statusCategory: {
            readonly statusCategoryId: string;
          } | null | undefined;
        };
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly isResolved: boolean | null | undefined;
  readonly statusField?: {
    readonly fieldId: string;
    readonly status: {
      readonly statusCategory: {
        readonly statusCategoryId: string;
      } | null | undefined;
    };
  } | null | undefined;
  readonly " $fragmentType": "IssueKeyCell59BadPattern";
};
export type IssueKeyCell59BadPattern$key = {
  readonly " $data"?: IssueKeyCell59BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueKeyCell59BadPattern">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "fieldId"
  },
  {
    "concreteType": "JiraStatus",
    "kind": "LinkedField",
    "name": "status",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "statusCategoryId"
          }
        ]
      }
    ]
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "IssueKeyCell59BadPattern",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isResolved"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraStatusField",
          "kind": "LinkedField",
          "name": "statusField",
          "plural": false,
          "selections": (v0/*: any*/)
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Literal",
              "name": "ids",
              "value": [
                "status"
              ]
            }
          ],
          "concreteType": "JiraIssueFieldConnection",
          "kind": "LinkedField",
          "name": "fieldsById",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueFieldEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": (v0/*: any*/),
                      "type": "JiraStatusField"
                    }
                  ]
                }
              ]
            }
          ],
          "storageKey": "fieldsById(ids:[\"status\"])"
        }
      ]
    }
  ],
  "type": "JiraIssue"
};
})();

(node as any).hash = "95ffb7d98b2bf254857fecb72bef599a";

export default node;
